export function getRandomInt(max) {
  return Math.floor(Math.random() * max);
}

export function randomIntFromInterval(min, max) {
  // min and max included
  return Math.floor(Math.random() * (max - min + 1) + min);
}

export function concatArray(array) {
  let newArray = [];
  array.forEach((element) => {
    newArray = newArray.concat(Object.entries(element)[0][1]);
  });
  return newArray;
}

export function areEqual(array1, array2) {
  return JSON.stringify(array1) === JSON.stringify(array2.sort());
}

export function mediaQueryHeight(mb, sm, xs) {
  if (mb) return 220;
  if (sm) return 170;
  if (xs) return 140;
  return 200;
}
